import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconArchive.tsx
const OutlinedFilledArchive = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.5-279 638-437l-53-54-65 65v-150h-80v150l-65-64-52 54 157.5 157ZM189-95q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.82-24.52Q237.88-866 258-866h444q19.09 0 37.16 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Z" })
});
const OutlinedArchive = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.5-279 638-437l-53-54-65 65v-150h-80v150l-65-64-52 54 157.5 157ZM189-639v450h582v-450H189Zm0 544q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.61-24.52Q237.47-866 258-866h444q19.5 0 37.37 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm257 312Z" })
});
const RoundedFilledArchive = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.82-24.52Q237.88-866 258-866h444q19.09 0 37.16 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm256.63 150q-16.63 0-28.13 11.76Q440-552.47 440-536v125l-46-46q-11.09-11-26.04-10.5Q353-467 341-454.64q-11 11.35-10.5 26.49.5 15.13 11.5 26.15l104 105q14 14 33.5 14t33.5-14l106-106q11-11.09 11-26.54Q630-445 618.14-457q-10.37-11-25.75-11Q577-468 566-457l-46 46v-125q0-16.47-11.87-28.24Q496.26-576 479.63-576Z" })
});
const RoundedArchive = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.63-576q-16.63 0-28.13 11.76Q440-552.47 440-536v125l-46-46q-11.09-11-26.04-10.5Q353-467 341-454.64q-11 11.35-10.5 26.49.5 15.13 11.5 26.15l104 105q14 14 33.5 14t33.5-14l106-106q11-11.09 11-26.54Q630-445 618.14-457q-10.37-11-25.75-11Q577-468 566-457l-46 46v-125q0-16.47-11.87-28.24Q496.26-576 479.63-576ZM189-639v450h582v-450H189Zm0 544q-39.8 0-66.9-27.1Q95-149.2 95-189v-493q0-15.88 5.5-31.06Q106-728.24 116-741l73-92q12.75-16.03 30.82-24.52Q237.88-866 258-866h444q19.09 0 37.16 8.48Q757.24-849.03 770-833l75 92q9 12.76 15 27.94 6 15.18 6 31.06v493q0 39.8-27.39 66.9Q811.21-95 771-95H189Zm34-631h513l-36.41-46H259l-36 46Zm257 312Z" })
});
const SharpFilledArchive = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m480-279 158-158-53-54-65 65v-150h-80v150l-65-64-52 54 157 157ZM95-95v-621l121-150h528l122 150v621H95Zm128-631h513l-36-46H259l-36 46Z" })
});
const SharpArchive = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m480-279 158-158-53-54-65 65v-150h-80v150l-65-64-52 54 157 157ZM189-639v450h582v-450H189ZM95-95v-621l121-150h528l122 150v621H95Zm128-631h513l-36-46H259l-36 46Zm257 312Z" })
});
const componentMap = {
	outlined: OutlinedArchive,
	"outlined-fill": OutlinedFilledArchive,
	rounded: RoundedArchive,
	"rounded-fill": RoundedFilledArchive,
	sharp: SharpArchive,
	"sharp-fill": SharpFilledArchive
};
const IconArchive = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconArchive };